import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
// import { downgradeInjectable } from "@angular/upgrade/static";
// import { IAngularStatic } from "angular";
import { Observable } from "rxjs";

import {
    IFlogoEnterpriseEnvInfo,
    ITCIEnvVars,
    ITCIProductVersion,
    SERVICE_URLS
} from "@tci/common";

// declare var angular: IAngularStatic;

/**
 * @deprecated Use Tenant Environment Service
 */
@Injectable()
export class NgWsService {

    constructor(
        private http: Http
    ) {}

    /**
     * @deprecated User Tenant Environment Service
     */
    public isFlogoEnt(): Observable<IFlogoEnterpriseEnvInfo> {
        const url = `${SERVICE_URLS.WIFLOGO}`;
        return this
            .http
            .get(url)
            .map((res) => {
                return res && <IFlogoEnterpriseEnvInfo>res.json() || null;
            });
    }

    public getProductVersion(): Observable<ITCIProductVersion> {
        const url = `${SERVICE_URLS.PRODUCT_VERSION}`;
        return this
            .http
            .get(url)
            .map(function (res) {
                return res && res.json() || null;
            });
    }
}

// if (typeof angular !== "undefined") {
//     angular
//         .module("main")
//         .factory("troposCommonServiceRestfulAPIWS", downgradeInjectable(NgWsService) as any);
// }
